function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M41.7359 29.8302C39.0411 29.7678 36.9074 27.5444 36.9702 24.8641C37.033 22.1839 39.2685 20.0617 41.9633 20.1242C44.6581 20.1867 46.7918 22.4101 46.729 25.0903C46.6662 27.7706 44.4307 29.8927 41.7359 29.8302Z",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M10.4377 29.8307C7.74211 29.8307 5.55694 27.6574 5.55694 24.9764C5.55694 22.2954 7.74211 20.1221 10.4377 20.1221C13.1332 20.1221 15.3184 22.2954 15.3184 24.9764C15.3184 27.6574 13.1332 29.8307 10.4377 29.8307Z",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M32.841 24.8726C32.8438 23.7218 33.0749 22.5828 33.5212 21.5209C33.9675 20.4591 34.6202 19.4954 35.4418 18.685C38.909 15.2508 44.533 15.2508 48.0001 18.685",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M1.25815 24.8724C1.25815 20.0145 5.21726 16.0776 10.1015 16.0776C14.9858 16.0776 18.944 20.0154 18.944 24.8732",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M20.2079 6.02637H3.78503V11.0527H20.2079V6.02637Z",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  d: "M42.9474 16.078L35.367 1H30.3133",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_7",
  d: "M32.8409 24.9766H18.9439",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_8",
  d: "M20.2079 11.0518C20.2079 11.0518 25.2615 29.8991 35.367 11.0518",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_9",
  d: "M3.78479 11.0518C3.78479 11.0518 -0.00586883 17.3342 1.25798 24.8728",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 31,
    viewBox: "0 0 49 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8d4f4be7.svg";
export { ForwardRef as ReactComponent };